// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qTJMc","right":"styles_right__3xzzH"};